"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const clsx_1 = require("clsx");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const ConditionalLink_1 = require("Views/Shared/Components/ConditionalLink");
const index_1 = require("../index");
const TileTitle = ({ isExternal, isDocument, isSoftware, isClickable, link, title, tileShape, hasCardHoverEffect, onClick, }) => {
    const icon = React.useMemo(() => {
        if (isExternal) {
            return (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "open-in-new", className: "ml-1", "aria-hidden": "true" });
        }
        if (isDocument || isSoftware) {
            return ((0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "file-download-outline", className: " ml-2xs text-bg-accent-01-primary", "aria-hidden": "true" }));
        }
        return '';
    }, [isDocument, isExternal, isSoftware]);
    if (title) {
        return ((0, jsx_runtime_1.jsxs)(ConditionalLink_1.ConditionalLink, { link: link, isNotClickable: !isClickable, onClick: onClick, className: (0, clsx_1.clsx)('heading-sm text-primary transition-colors', hasCardHoverEffect && 'group-hover:underline', tileShape === index_1.TileShapeEnum.Wide && 'line-clamp-2'), children: [title, icon] }));
    }
    return null;
};
exports.TileTitle = TileTitle;
